import { render, staticRenderFns } from "./BaseNav.vue?vue&type=template&id=0674dc5b&"
import script from "./BaseNav.vue?vue&type=script&lang=js&"
export * from "./BaseNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0674dc5b')) {
      api.createRecord('0674dc5b', component.options)
    } else {
      api.reload('0674dc5b', component.options)
    }
    module.hot.accept("./BaseNav.vue?vue&type=template&id=0674dc5b&", function () {
      api.rerender('0674dc5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/BaseNav.vue"
export default component.exports